import type { FlatNamespace } from 'i18next'

import type { LanguageId } from '@mntn-dev/domain-types'

import { initI18next } from './utilities/init-18next.ts'

export async function getTranslationForEmail(
  lng: LanguageId,
  ns?: FlatNamespace
) {
  const i18nextInstance = await initI18next(lng, ns, false)

  const t = i18nextInstance.getFixedT(lng, ns)

  return {
    t,
    i18n: i18nextInstance,
  }
}
